/* Sidebar presentation only. The unchanged inline theme script owns heading IDs. */
(() => {
  const root = document.querySelector('[data-hb-article-layout]');
  if (!root) return;
  const content = root.querySelector('#article-content');
  const toc = root.querySelector('#article-toc');
  const list = root.querySelector('#toc-list');
  if (!content || !toc || !list) return;

  // Show the original list in a scrollable sidebar. Do not regenerate its anchors.
  list.classList.remove('hb-toc-truncated');
  list.querySelector('.hb-toc__expand-item')?.remove();
  const desktop = window.matchMedia('(min-width: 1100px)');
  toc.open = desktop.matches;
  desktop.addEventListener('change', event => { toc.open = event.matches; });

  const links = new Map();
  list.querySelectorAll('a').forEach(link => {
    const id = link.getAttribute('href').slice(1);
    const heading = id && document.getElementById(id);
    if (heading && content.contains(heading)) links.set(heading, link);
  });
  if ('IntersectionObserver' in window && links.size) {
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (!visible.length) return;
      for (const link of links.values()) link.removeAttribute('aria-current');
      links.get(visible[0].target)?.setAttribute('aria-current', 'location');
    }, {rootMargin: '-100px 0px -55% 0px', threshold: 0});
    for (const heading of links.keys()) observer.observe(heading);
  }
})();
